export default __webpack_public_path__ + "static/media/91.2af47c69.jpg";